export const EXTERNAL_INTEROGATION_REPORT = 'EXTERNAL_INTEROGATION_REPORT';
export const EXTERNAL_INTEROGATION = 'EXTERNAL_INTEROGATION';
export const REPORT = 'REPORT';
export const EntityTypePartner = 'Partner';
export const ValidityTypeNumberOfDays = 'DAYS_NO';
